import { createStyles } from "@mantine/core";
import { ThemeMode } from "../../../../Enums/themeMode";

export const useStyles = createStyles((theme) => ({
  table: {
    marginBottom: "3rem",
    marginTop: "1rem",
  },
  tableHeader: {
    backgroundColor:
      theme.colorScheme === ThemeMode.DARK
        ? theme.colors.dark[4]
        : theme.colors.gray[3],
  },
  headText: {
    color:
      theme.colorScheme === ThemeMode.DARK
        ? theme.colors.dark[1]
        : theme.colors.light[1],
  },
  requestBoxContainer: {
    border: "solid 1px",
    width: 56,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 3,
    paddingBottom: 3,
    marginRight: "1rem",
  },
  quantityText: {
    marginLeft: 5,
    color:
      theme.colorScheme === ThemeMode.DARK
        ? theme.colors.dark[0]
        : theme.colors.light[1],
  },
  actionsContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: '1rem'
  },
  iconTrashContainer: {
    backgroundColor: "#E63324",
    borderRadius: 50,
    marginRight: 10,
    alignSelf: "center",
    alignItems: "center",
  },
  iconActionContainer: {
    backgroundColor: "#27A536",
    borderRadius: 50,
    marginRight: 10,
    alignSelf: "center",
    alignItems: "center",
    "&: hover": {
      backgroundColor: "#27A536",
      opacity: 0.5,
    },
  },
  emptyResultsMessage: {
    textAlign: "center",
    marginTop: "1rem",
    position: "absolute",
    color:
      theme.colorScheme === ThemeMode.DARK
        ? theme.colors.gray[1]
        : theme.colors.light[1],
    width: '100%'
  },
  bodyContainer: {
    justifyContent: "center",
  },
  tableText: {
    color:
      theme.colorScheme === ThemeMode.DARK
        ? theme.colors.gray[1]
        : theme.colors.light[1],
  },
  requestMainContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  roles: {
    color:
      theme.colorScheme === ThemeMode.DARK
        ? theme.colors.dark[0]
        : theme.colors.light[1],
    textAlign: 'center',
    borderRadius: 12
  }
}));
